module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Green3_Side.360638c4.png";